import { useDispatch } from "react-redux";
import { getPosts } from "./actions/albums"
import { clear_song } from "./actions/song"
import { aToggleArtworkDisplay } from "./actions/toggleArtworkDisplay"

import AlbumContainer from "./components/albumcontainer/albumcontainer";
import Audio from "./components/audioplayer/audio";
import SearchField from "./components/searchfield/searchfield";


function App()
{




  const dispatch = useDispatch();


  const toggleArtworkDisplay = () =>
  {
    dispatch(aToggleArtworkDisplay());
  }



  const handle_buttons = (type) =>
  {
    dispatch(clear_song());
    dispatch(getPosts(type));
  }

  return (
    <div>
      <button onClick={() => handle_buttons("mp3")}>MP3</button>
      <button onClick={() => handle_buttons("native")}>Native</button>
      {<button onClick={() => toggleArtworkDisplay()}>Art</button>}
      <SearchField />
      <Audio />
      <AlbumContainer />
    </div>
  );
}

export default App;
